import { createFileRoute } from '@tanstack/react-router';
import { CurriculumListPage } from '@/features/Curriculum/CurriculumListPage';

export const Route = createFileRoute('/admin/curriculum/')({
  component: CurriculumListPage,
});
